/* eslint-disable react/no-multi-comp */
import React from "react";

import { Field, type WrappedFieldProps } from "redux-form/dist/redux-form";

import FormField from "../Form.Field";
import FormLabel from "../Form.Label";
import FormHelp from "../Form.Help";
import FormWrapper from "../Form.Wrapper";
import FormValidation from "../Form.Validation";
import { generateFieldId, returnFieldState } from "../formMetaHelpers";

import RadioCard from "./RadioCard";

interface RadioCardFieldProps {
  name: string;
  disabled?: boolean;
  children: React.ReactNode;
  label?: string;
  help?: string;
  fieldProps?: object;
  validate?: any[];
  normalize?: Function;
  format?: Function;
  parse?: Function;
  warn?: any[];
  [key: string]: any; // Allow other props for Field
}

interface RadioCardFieldComponentProps extends WrappedFieldProps {
  disabled?: boolean;
  children: React.ReactNode;
  label?: string;
  help?: string;
  fieldProps?: object;
}

function RadioCardFieldComponent({
  input,
  meta,
  disabled,
  children,
  label,
  help,
  fieldProps = {}
}: RadioCardFieldComponentProps) {

  const id = generateFieldId("radio-card", meta, {}, input);
  const { isInvalid } = returnFieldState(meta);

  return (
    <FormField
      className="field-radio"
      {...fieldProps}>

      {label && (
        <FormLabel htmlFor={id}>
          {label}
        </FormLabel>
      )}

      <FormWrapper>
        <RadioCard
          id={id}
          name={input.name}
          value={input.value}
          onChange={input.onChange}
          disabled={disabled}
          label={label}>
          {children}
        </RadioCard>
      </FormWrapper>

      {help && <FormHelp>{help}</FormHelp>}

      <FormValidation
        errorMessage={meta.error}
        isVisible={isInvalid} />

    </FormField>
  );
}

function RadioCardField({
  name,
  disabled,
  children,
  label,
  help,
  fieldProps,
  validate,
  normalize,
  format,
  parse,
  warn,
  ...restProps
}: RadioCardFieldProps) {
  return (
    // @ts-ignore
    <Field
      name={name}
      component={RadioCardFieldComponent}
      validate={validate}
      normalize={normalize}
      format={format}
      parse={parse}
      warn={warn}
      props={{
        disabled,
        children,
        label,
        help,
        fieldProps
      }}
      {...restProps} />
  );
}

RadioCardField.displayName = "RadioCardField";
RadioCardField.Option = RadioCard.Option;

export default RadioCardField;
